module.exports = __webpack_public_path__ + "media/images/card-img-a01871f2.png";